import React, { useState } from 'react';
import { Alert, Button, Icon, Input } from '@polichat/flamboyant';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

import { CustomModal, CustomModalHeader } from './DeleteChannelModal.styles';

export default function DeleteChannelModal({
  isOpen,
  toggle: toggleFromDad,
  channelData,
  handleDeleteChannel,
  isLoading,
}) {
  const [confirmInput, setConfirmInput] = useState('');
  
  const deleteChannelModalTitle = useGlotaT('spa.certification.deleteChannelModalTitle');
  const deleteChannelModalWarning = useGlotaT('spa.certification.deleteChannelModalWarning');
  const deleteChannelModalImportant = useGlotaT('spa.certification.deleteChannelModalImportant');
  const deleteChannelModalConfirm = useGlotaT('spa.certification.deleteChannelModalConfirm');
  const deleteChannelModalButton = useGlotaT('spa.certification.deleteChannelModalButton');
  const deleteChannelModalLoading = useGlotaT('spa.certification.deleteChannelModalLoading');

  const modalToggle = () => {
    toggleFromDad();
    setConfirmInput('');
  };

  const confirmText = deleteChannelModalConfirm.replace(':channelName', channelData?.name || '');

  return (
    <>
      <CustomModal isOpen={isOpen} toggle={modalToggle} className="ModalMain">
        <CustomModalHeader toggle={modalToggle}>
          <Icon icon="poli-icon pi-delete-fill" color="var(--danger)" />
          {deleteChannelModalTitle}
        </CustomModalHeader>
        <Alert color="danger">
          {deleteChannelModalWarning}
        </Alert>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {deleteChannelModalImportant}
          <br />
          <br />
          <div style={{ marginBottom: '0.5rem' }}>
            {confirmText}
          </div>
          <Input
            value={confirmInput}
            onChange={(e) => setConfirmInput(e.target.value)}
          />
          <br />
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              color="danger"
              disabled={confirmInput !== channelData.name || isLoading}
              onClick={handleDeleteChannel}
              style={{
                cursor: isLoading ? 'wait' : null,
              }}
            >
              {isLoading
                ? deleteChannelModalLoading
                : deleteChannelModalButton}
            </Button>
          </div>
        </div>
      </CustomModal>
    </>
  );
}
